/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationContent } from './notificationContent';


export interface NotificationApiModel { 
    id?: string;
    type?: string;
    date?: string;
    service?: string;
    content?: NotificationContent;
    status?: NotificationApiModelStatusEnum;
    user?: string;
    hidden?: boolean;
}
export enum NotificationApiModelStatusEnum {
    not_viewed = 'not viewed',
    viewed = 'viewed'
};



